export default __webpack_public_path__ + "static/media/TH.b8719833.svg";